// [BD Feat] JS for the recipes slider of the collection-recipes section

function initRecipeSliders() {
  document.querySelectorAll('.collection-recipes-section[data-section-id]').forEach(function (sectionWrapper) {
    const sectionId = sectionWrapper.getAttribute('data-section-id');
    if (!sectionId) return;

    const recipesList = document.querySelector(`#recipe-slider-${sectionId}`);
    if (!recipesList) {
      console.warn(`#recipe-slider-${sectionId} not found in the DOM`);
      return;
    }

    const recipesListItems = recipesList?.querySelectorAll('.recipe-media-item') || [];
    const tabsLoop = checkChildWidth(recipesList, recipesListItems);

    // Destroy existing slider if it exists
    const existingSlider = Flickity.data(recipesList);
    if (existingSlider) {
      existingSlider.destroy();
    }

    if (tabsLoop) {
      new Flickity(recipesList, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        groupCells: 1,
        wrapAround: tabsLoop
      });
    }
  });
}

function checkChildWidth(parentElement, childElements) {
  try {
    const parentWidth = parentElement.offsetWidth;
    let totalChildWidth = 0;

    childElements.forEach((child, index) => {
      const childWidth = child.offsetWidth;
      const style = window.getComputedStyle(child);
      const marginRight = parseInt(style.marginRight, 10) || 0;
      totalChildWidth += childWidth + (index < childElements.length - 1 ? marginRight : 0);
    });

    return totalChildWidth > parentWidth;
  } catch (error) {
    console.error("An error occurred:", error);
    return false;
  }
}

// Resize re-init
let resizeCollectionRecipeSliderTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeCollectionRecipeSliderTimer);
  resizeCollectionRecipeSliderTimer = setTimeout(() => {
    initRecipeSliders();
  }, 300);
});

(async () => {
  const SHOP_DOMAIN = 'myline24.myshopify.com';
  const STOREFRONT_TOKEN = 'b4a2a3cde00bde9fb84e2e2bf47d7f1a';

  function getCollectionHandle() {
    const path = window.location.pathname;
    const match = path.match(/^\/collections\/([^\/]+)/);
    return match ? match[1] : null;
  }

  const collectionHandle = getCollectionHandle();
  if (!collectionHandle) {
    console.error('❌ Not on a collection page or collection handle not found in URL');
    return;
  }

  async function fetchMetafield() {
    const query = `
      query getCollectionMetafield($handle: String!) {
        collection(handle: $handle) {
          metafield(namespace: "custom", key: "recipe_list_from_handles") {
            value
          }
        }
      }
    `;

    const res = await fetch(`https://${SHOP_DOMAIN}/api/2025-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables: { handle: collectionHandle } }),
    });

    const { data, errors } = await res.json();
    if (errors) {
      console.error('❌ GraphQL errors:', errors);
      return null;
    }

    return data.collection?.metafield?.value || null;
  }

  function parseArticleHandles(rawValue) {
    if (!rawValue) return [];

    let paths = [];

    try {
      const parsedJSON = JSON.parse(rawValue);
      paths = Array.isArray(parsedJSON) ? parsedJSON : rawValue.split(/\r?\n|,/).map(s => s.trim());
    } catch {
      paths = rawValue.split(/\r?\n|,/).map(s => s.trim());
    }

    return paths
      .map(path => {
        const match = path.match(/^\/blogs\/([^\/]+)\/([^\/]+)$/);
        return match ? { blogHandle: match[1], articleHandle: match[2] } : null;
      })
      .filter(Boolean);
  }

  async function fetchArticlesByBlog(blogHandle) {
    const query = `
      query getArticlesByBlog($blogHandle: String!) {
        blogByHandle(handle: $blogHandle) {
          articles(first: 250) {
            edges {
              node {
                title
                handle
                onlineStoreUrl
                image {
                  url
                  altText
                }
                publishedAt
              }
            }
          }
        }
      }
    `;

    const res = await fetch(`https://${SHOP_DOMAIN}/api/2025-04/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables: { blogHandle } }),
    });

    const { data, errors } = await res.json();
    if (errors) {
      console.error(`❌ GraphQL errors fetching articles for blog ${blogHandle}:`, errors);
      return null;
    }

    return data.blogByHandle?.articles?.edges.map(edge => edge.node) || [];
  }

  try {
    const rawMetafieldValue = await fetchMetafield();
    const section = document.querySelector('section[data-section-type="collection-recipes"]');

    if (!rawMetafieldValue || !section) {
      console.warn('No metafield or section found, hiding section');
      if (section) section.style.display = 'none';
      return;
    }

    const articlesToFetch = parseArticleHandles(rawMetafieldValue);
    if (articlesToFetch.length === 0) {
      console.warn('No valid article handles found, hiding section');
      section.style.display = 'none';
      return;
    }

    const blogGroups = articlesToFetch.reduce((acc, { blogHandle, articleHandle }) => {
      if (!acc[blogHandle]) acc[blogHandle] = [];
      acc[blogHandle].push(articleHandle);
      return acc;
    }, {});

    let matchedArticles = [];

    for (const [blogHandle, handles] of Object.entries(blogGroups)) {
      const blogArticles = await fetchArticlesByBlog(blogHandle);
      if (!blogArticles || blogArticles.length === 0) continue;

      const matches = blogArticles.filter(a => handles.includes(a.handle));
      matchedArticles = matchedArticles.concat(matches);
    }

    if (matchedArticles.length === 0) {
      console.warn('No matching articles found, hiding section');
      section.style.display = 'none';
      return;
    }

    const sectionId = section.getAttribute('data-section-id');
    const container = document.getElementById(`recipe-slider-${sectionId}`);
    if (!container) {
      console.error(`Container with ID recipe-slider-${sectionId} not found`);
      return;
    }

    let html = '';
    matchedArticles.forEach(article => {
      const title = article.title;
      const url = article.onlineStoreUrl;
      const imgSrc = article.image?.url || '';
      const altText = article.image?.altText || title;

      const srcset = `
        ${imgSrc}?width=165 165w,
        ${imgSrc}?width=350 350w,
        ${imgSrc}?width=750 750w,
        ${imgSrc}?width=1200 1200w,
        ${imgSrc} 1280w
      `.trim().replace(/\s+/g, ' ');

      html += `
        <div class="recipe-media-item">
          <a href="${url}" class="recipe-media-item-link" aria-label="${altText}">
            <div class="image-parent">
              <img
                class="image"
                srcset="${srcset}"
                src="${imgSrc}?width=1500"
                sizes="(min-width: px)"
                alt="${altText}"
                loading="lazy"
                width="1280"
                height="410"
              >
              <div class="rounded-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="0.8125rem" height="0.75rem" viewBox="0 0 13 12" fill="none">
                  <path d="M0.5 6H11.5M11.5 6L6.16667 1M11.5 6L6.16667 11" stroke="var(--primary-fill-color)" stroke-width="0.8" stroke-linecap="round"></path>
                </svg>
              </div>
            </div>
            <p class="recipe-title paragraph-xs">${title}</p>
          </a>
        </div>
      `;
    });

    container.innerHTML = html;
    initRecipeSliders(); // slider init
  } catch (error) {
    console.error('Unexpected error:', error);
    const section = document.querySelector('section[data-section-type="collection-recipes"]');
    if (section) section.style.display = 'none';
  }
})();
